import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {columns} from './columns/_columns'
import {Role} from '../core/_models'
import {KTCardBody} from '../../../../../_metronic/helpers'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import { RolesListPagination } from '../../roles-list/components/pagination/RolesListPagination'
import { RolesListLoading } from '../../roles-list/components//loading/RolesListLoading'

const RolesTable = () => {
  const {response, isLoading} = useQueryResponse()
  const {state, updateState} = useQueryRequest()
  const data = useMemo(() => response?.data || [], [response])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0 bg-light'>
              {headers.map((column: ColumnInstance<Role>) => (
                <CustomHeaderColumn key={column.id} column={column} state={state} updateState={updateState} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Role>, i) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    })}
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={4}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <RolesListPagination />
      {isLoading && <RolesListLoading/>}
    </KTCardBody>
  )
}

export {RolesTable} 